import React from "react"
import { INLINES, MARKS, BLOCKS } from "@contentful/rich-text-types"
import Prism from "prismjs"

import { convertStringToKebabCase, hasTrailingSlash, processShortcodes } from "@utils"
import ContentBlockquote from "./components/ContentBlockquote/ContentBlockquote"

// Source here: https://github.com/contentful/rich-text/blob/master/packages/rich-text-react-renderer/src/index.tsx
export const textOptions = {
  renderNode: {
    [BLOCKS.HEADING_2]: (node, children) => {
      const h2Id = convertStringToKebabCase(node.content.map(({ value }) => `${value}`).join(" "))
      return <h2 id={h2Id}>{children}</h2>
    },
    [BLOCKS.QUOTE]: (node, children) => {
      console.log(node, children)
      return (
        <ContentBlockquote contentful_id="">
          {children}
        </ContentBlockquote>
      )
    },
    [INLINES.ENTRY_HYPERLINK]: ({
      data,
      content: [
        { value }
      ]
    }) => {
      const slug = data?.target?.slug
      // Add a trailing slash to all linked entries in content text
      return <a href={`/${slug || '404'}${!hasTrailingSlash(slug) && '/'}`} rel="noreferrer">{value}</a>
    },

    [INLINES.HYPERLINK]: ({
      data,
      content: [
        { value }
      ]
    }) => {
      const isDocsLink = data?.uri.includes("beacon-link=")

      if (isDocsLink) {
        const articleId = data.uri.replace("beacon-link=", "")
        return <a href="#" data-beacon-article={articleId}>{value}</a>
      }

      const isRelative = data?.uri.startsWith("#")
      const href = data?.uri ? processShortcodes(data.uri) : "/404"
      return <a href={href} target={isRelative ? "_self" : "_blank"} rel="noreferrer">{value}</a>
    },
  },
  renderMark: {
    [MARKS.BOLD]: text => <b>{text}</b>,
    [MARKS.ITALIC]: text => <i>{text}</i>,
    [MARKS.UNDERLINE]: text => <u>{text}</u>,
    [MARKS.CODE]: text => {
      if (typeof text === "string" && text.includes("iframe-embed")) {
        const iframeHtml = text.replace(/iframe-embed/g, "iframe")
        return (
          <div
            dangerouslySetInnerHTML={{ __html: iframeHtml }}
            style={{
              aspectRatio: "16 / 9",
              borderRadius: "var(--border-radius--M)",
              margin: "var(--spacing--M) 0",
              overflow: "hidden",
              position: "relative",
              width: "100%",
            }}
          />
        )
      }
      try {
        const _html = Prism.highlight(text, Prism.languages.javascript)
        return (
          <>
            <link href="/css/prism/prism.min.css" rel="stylesheet" />
            {text.includes("\n") ? (
              <pre><code dangerouslySetInnerHTML={{ __html: _html }} /></pre>
            ) : (
              <code dangerouslySetInnerHTML={{ __html: _html }} />
            )}
          </>
        )
      } catch (err) {
        console.error(err)
        return <h4>Code block could not be loaded.</h4>
      }
    },
  }
}